import React from 'react';
import styles from './DashboardContent.module.css';

type DashboardContentProps = {
    title: string;
    children: React.ReactNode;
    actionItem?: React.ReactNode;
};

function DashboardContent({ title, children, actionItem }: DashboardContentProps) {
    return (
        <div className={styles.contentView}>
            <div className={styles.header}>
                <span className={styles.title}>{title}</span>
                {actionItem && actionItem}
            </div>
            <div className={styles.body}>{children}</div>
        </div>
    );
}

export default DashboardContent;
